import { createContext, useContext } from "react";
import PropTypes from 'prop-types'

const RadarIsChecked = createContext();

// Os três radares ficam sempre selecionados — sem controle de usuário.
const radarChecked = {
  cangucuChecked: true,
  morroDaIgrejaChecked: true,
  santiagoChecked: true,
};

export const RadarIsCheckedProvider = ({ children }) => {
  return (
    <RadarIsChecked.Provider value={radarChecked}>
      {children}
    </RadarIsChecked.Provider>
  );
};

export const UseRadarIsChecked = () => {
  return useContext(RadarIsChecked);
};

RadarIsCheckedProvider.propTypes = {
  children: PropTypes.node
}
